import { PrintingProfileDtoToEntity } from "src/app/features/PrintingProfile/services/mappers/PrintingProfileDtoToEntity";
import type { PrintingProfileDto } from "src/app/features/PrintingProfile/types/PrintingProfileDto";
import type { PrintingProfileEntity } from "src/app/features/PrintingProfile/types/PrintingProfileEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const PrintingProfileTableDtoMapper = (
    input: Readonly<ResourcePageDto<PrintingProfileDto>>,
): ResourcePageEntity<PrintingProfileEntity> => {
    return {
        list: input.list ? input.list.map(PrintingProfileDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
